import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiHome } = FiIcons;

const Layout = ({ children }) => {
  const location = useLocation();
  // Using raw=1 for direct embedding
  const logoUrl = "https://www.dropbox.com/scl/fi/m1e6agmnwiz92uid4bx3y/Gyso-Call-Logo.png?rlkey=encbf5fh2ngjiiaqwtploq2ec&st=4fwrw1vl&raw=1";

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex">
              <div className="flex-shrink-0 flex items-center mr-8">
                <Link to="/">
                  <img className="h-10 w-auto" src={logoUrl} alt="Gyso Call" />
                </Link>
              </div>
              <div className="flex space-x-8">
                <Link
                  to="/"
                  className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium ${
                    location.pathname === '/'
                      ? 'border-blue-500 text-gray-900'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <SafeIcon icon={FiHome} className="mr-2" />
                  Home
                </Link>
                <Link
                  to="/twilio"
                  className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium ${
                    location.pathname.startsWith('/twilio')
                      ? 'border-blue-500 text-gray-900'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <SafeIcon icon={FiPhone} className="mr-2" />
                  Call Centre
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <main>{children}</main>
    </div>
  );
};

export default Layout;